import queryString from 'query-string';

export function getQuery(queryName: string): string {
  const parse = queryString.parse(window.location.search);  
  // queryString.parse 内部已经 decodeURIComponent，不要重复，否则遇到 % 会报错：Uncaught URIError: URI malformed
  return parse[queryName] as string;
}
